module.exports = __webpack_public_path__ + "static/media/cartShoppingSolid.2d25341b.svg";